module.exports = __webpack_public_path__ + "static/media/icon_video.cc6a64a8.svg";